(function () {
  const selectors = [
    '.ap-dynamic-compare-price',
    '[data-ap-dynamic-compare-price]'
  ];

  const initializedElements = new WeakSet();

  function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
  }

  function randomInterval() {
    return Math.floor(randomBetween(4000, 12000));
  }

  function getWeightedUplift() {
    // 60% delle volte mostra +0%
    if (Math.random() < 0.6) {
      return 0;
    }

    // 40% delle volte mostra un aumento casuale tra +1% e +4%
    return randomBetween(0.01, 0.04);
  }

  function formatMoney(cents, locale, currency) {
    const amount = cents / 100;

    return new Intl.NumberFormat(locale || 'it-IT', {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  }

  function updatePrice(element) {
    const baseCents = Number(element.dataset.baseCents);
    const currency = element.dataset.currency || 'EUR';
    const locale = element.dataset.locale || 'it-IT';

    if (!baseCents || baseCents <= 0) return;

    const uplift = getWeightedUplift();

    // Arrotonda sempre all'euro intero, quindi il prezzo finisce con ,00
    const dynamicEuros = Math.round((baseCents * (1 + uplift)) / 100);
    const dynamicCents = dynamicEuros * 100;

    element.textContent = formatMoney(dynamicCents, locale, currency);
  }

  function startPriceLoop(element) {
    if (initializedElements.has(element)) return;

    initializedElements.add(element);

    // All'apertura resta il prezzo originale già stampato da Liquid.
    // Il primo cambio parte solo dopo 6-12 secondi.
    function loop() {
      updatePrice(element);
      setTimeout(loop, randomInterval());
    }

    setTimeout(loop, randomInterval());
  }

  function initDynamicPrices(root) {
    const scope = root || document;

    const priceElements = scope.querySelectorAll
      ? scope.querySelectorAll(selectors.join(','))
      : [];

    priceElements.forEach(function (element) {
      startPriceLoop(element);
    });

    // Se il root stesso è un prezzo dinamico
    if (
      root &&
      root.matches &&
      root.matches(selectors.join(','))
    ) {
      startPriceLoop(root);
    }
  }

  function observeNewPrices() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          initDynamicPrices(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDynamicPrices(document);
    observeNewPrices();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initDynamicPrices(event.target);
  });
})();